"use strict";

var conversions = require("webidl-conversions");
var utils = require("./utils.js");
exports.convert = function (globalObject, value) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$context = _ref.context,
    context = _ref$context === void 0 ? "The provided value" : _ref$context;
  if (typeof value !== "function") {
    throw new globalObject.TypeError(context + " is not a function");
  }
  function invokeTheCallbackFunction(mutations, observer) {
    var thisArg = utils.tryWrapperForImpl(this);
    var callResult;
    mutations = utils.tryWrapperForImpl(mutations);
    observer = utils.tryWrapperForImpl(observer);
    callResult = Reflect.apply(value, thisArg, [mutations, observer]);
  }
  invokeTheCallbackFunction.construct = function (mutations, observer) {
    mutations = utils.tryWrapperForImpl(mutations);
    observer = utils.tryWrapperForImpl(observer);
    var callResult = Reflect.construct(value, [mutations, observer]);
  };
  invokeTheCallbackFunction[utils.wrapperSymbol] = value;
  invokeTheCallbackFunction.objectReference = value;
  return invokeTheCallbackFunction;
};